import { Image, ScrollView, StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { Theme, ThemedText, ThemedView } from '@app/theme'
import PageHeaders from '@app/sharedComponents/CommonHeader/CommonHeader'
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@app/navigationApp/types';
import { ThemedTouchableOpacity } from '@app/theme/Components';
import CopyIcon from "../../assets/Icons/CopyIcon";
import { useTheme } from '@shopify/restyle';
import Clipboard from '@react-native-clipboard/clipboard';
import { useAppSelector } from '@app/store/hooks';


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'BAJAJ_SHUTDOWN'>;

const BajajShutDownInfoScreen = ({ navigation }: ScreenProps) => {

    const loanAccountID = useAppSelector((state) => state?.auth?.userDetails?.linkedCredits[0]?.lenderCreditId);

    const copyToClipboard = () => {
        Clipboard.setString(loanAccountID ?? '');
    };


    const { colors } = useTheme<Theme>()
    return (
        <ThemedView bg='bg-fill-primary' flex={1}>
            <PageHeaders pageName="BAJAJ_SHUTDOWN" navigation={navigation} />
            <ScrollView>
                <ThemedView overflow='hidden' borderWidth={1} borderRadius='lg' borderColor='border-secondary' mt='lg' mx='lg' bg='white'>
                    <ThemedView padding='lg' backgroundColor='bg-fill-emphasis-primary-1' height={100}>
                        <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Bajaj_Finance_Logo.png" }} style={{ height: 20, width: 230 }} />
                        <ThemedText variant='b3b'>Services no longer on Volt {'\n'}Money app</ThemedText>
                        <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/out_of_service.png" }} style={{ height: 80, width: 80, position: 'absolute', right: 20, bottom: 0 , zIndex:10 }} />
                    </ThemedView>
                    <ThemedTouchableOpacity onPress={copyToClipboard} flexDirection='row' justifyContent='space-between' padding='lg'>
                        <ThemedView flexDirection='row' flex={1}>
                            <ThemedText variant='b3r'>Loan A/c Number:  </ThemedText>
                            <ThemedTouchableOpacity>
                                <ThemedText variant='b3b'>{loanAccountID}</ThemedText>
                            </ThemedTouchableOpacity>
                        </ThemedView>
                        <CopyIcon color={colors['icon-action-primary']} />
                    </ThemedTouchableOpacity>

                </ThemedView>

                <ThemedView padding='lg'>
                    <ThemedText mt='md' variant='b3r'>At Volt, we understand that this news may come as a shock and could impact your usual experience. Please be assured that our core philosophy is to always prioritise our customers’ interests. We remain committed to extending all reasonable assistance from our side, including any support necessary to facilitate a smooth and seamless transition for you. </ThemedText>
                    <ThemedText mt='md' variant='b3r'>We sincerely regret any inconvenience or disruption this situation may have caused you and greatly appreciate your understanding and support during this period.</ThemedText>
                </ThemedView>

                <ThemedView padding='lg'>
                    <ThemedText mb='md' variant='b3s'>We want to assure you</ThemedText>
                    <ThemedView borderWidth={1} borderColor='border-primary' borderRadius='lg' padding='lg'>
                        <ThemedView flexDirection='row' alignItems='center'>
                            <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/bfl_icon_1.png" }} style={{ height: 32, width: 32 }} />
                            <ThemedText flex={1} ml='md' variant='b3r'>Your loan is 100% safe and unaffected.</ThemedText>
                        </ThemedView>
                        <ThemedView mt='xl' flexDirection='row' alignItems='center'>
                            <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/bfl_icon_2.png" }} style={{ height: 32, width: 32 }} />
                            <ThemedText flex={1} ml='md' variant='b3r'>There is no change to your account terms</ThemedText>
                        </ThemedView>
                        <ThemedView mt='xl' flexDirection='row' alignItems='center'>
                            <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/bfl_icon_3.png" }} style={{ height: 32, width: 32 }} />
                            <ThemedText flex={1} ml='md' variant='b3r'>Servicing for loans with other lenders will continue as usual on Volt</ThemedText>
                        </ThemedView>

                    </ThemedView>
                </ThemedView>
                <ThemedView padding='lg'>
                    <ThemedText variant='b3s'>What has happened?</ThemedText>
                    <ThemedText mt='md' variant='b3r'>Bajaj Finance Limited ("BFL") has abruptly discontinued our ability to support you via our platform, Volt Money, as regards the loans availed by you from BFL (“BFL Loan”).
                     Accordingly, effective immediately, we will no longer be able to facilitate any services or assistance concerning your BFL Loan via Volt Money. </ThemedText>
                </ThemedView>
                <ThemedView padding='lg'>
                    <ThemedText variant='b3s'>What you can do next?</ThemedText>
                    <ThemedText mt='md' variant='b3r'>All future correspondence, payments, support requests, queries, and any other information orclarifications related to your BFL Loan must be directed to BFL using the contact details provided below:</ThemedText>

                    <ThemedView flexDirection='row' mt='lg' alignItems='center'>
                        <ThemedView height={4} width={4} borderRadius='full' backgroundColor='text-primary' />
                        <ThemedText ml='sm' variant='b3r'>Email: las.crm@bajajfinserv.in</ThemedText>
                    </ThemedView>

                    <ThemedView flexDirection='row' mt='sm' alignItems='center'>
                        <ThemedView height={4} width={4} borderRadius='full' backgroundColor='text-primary' />
                        <ThemedText ml='sm' variant='b3r'>Phone: 020-69013372</ThemedText>
                    </ThemedView>

                </ThemedView>
                  <ThemedView mb='3xl' padding='lg'>
                    <ThemedText variant='b3s'>Disclaimer</ThemedText>
                    <ThemedText mt='md' variant='b3r'>This message is intended exclusively for existing borrowers of Bajaj Finance Limited who availed loans through the Volt Money platform. Salter Technologies Private Limited disclaims any further involvement, responsibility, or liability in respect of the origination, servicing, or management of such loans. All communications, queries, and obligations pertaining to these loans shall be directed solely to BFL</ThemedText>
                </ThemedView>
            </ScrollView>
        </ThemedView>
    )
}

export default BajajShutDownInfoScreen

const styles = StyleSheet.create({})